<ng-container>
  <div class="row align-items-center">
    <div class="col col-md-12">
      <pr-input-radio
        formControlName="schema3"
        direction="column"
        [isDefault]="false"
        [options]="options"
        [columns]="2"
        [derrors]="derrors"
      >
      </pr-input-radio>
    </div>
  </div>
</ng-container>
